import { OrbitControls } from '@react-three/drei'
import {
  MovementCalculator,
  ShipHullCamera3D,
} from 'features/assetViz/cameras/ShipHullCamera3D'
import { GLTFLoader } from 'features/assetViz/objects/gltf/GLTFLoader'
import { SceneFactoryConfig } from 'features/assetViz/scenes/sceneFactory'
import React from 'react'
import { GeckoAssetModelType, GeckoComponentModelType } from 'types'

export const ShipHullSceneConfig: SceneFactoryConfig = {
  name: 'ShipHull',
  assetModels: [GeckoAssetModelType.Ship],
  componentModels: [GeckoComponentModelType.BasicShipHull],
  sceneFunc: () => <ShipHullScene />,
}

export const ShipHullScene: React.FC = () => {
  const getMovementForCursorDelta = React.useCallback<MovementCalculator>(
    (cursorDelta) => cursorDelta,
    []
  )

  return (
    <>
      <directionalLight position={[5, 5, 5]} intensity={0.5} castShadow />
      <directionalLight position={[-5, 5, -5]} intensity={0.3} />
      <ambientLight intensity={0.5} />
      <OrbitControls />
      <ShipHullCamera3D getMovementForCursorDelta={getMovementForCursorDelta} />
      <GLTFLoader />
    </>
  )
}
